import DefinitionFieldP from './recordm.presenter.definition.field.js';
import DefinitionFieldsNanny from './recordm.presenter.definition.fieldnanny.js';

var DefinitionFieldsP = function(core, view){

    var _nanny = new DefinitionFieldsNanny(core);
    var _fieldBuilder = new DefinitionFieldP.NewFieldBuilder(core, {expand: () => {
       // nothing to do, we are at the top
    }});

    view.init({
        top_field_add: function(){
            var newField = _fieldBuilder.buildFor(_nanny);

            core.translate('recordm.definition', newField.content());

            view.addTopField(newField);
            _nanny.addChildAfter(0, newField);
        },

        top_field_drop: function($dropedElement){
            var oldNanny = $dropedElement.data('nanny');

            //remove the Presenter from the oldNanny
            var hisPresenter = oldNanny.removeChild($dropedElement.data('fieldId'));

            //set the new nanny, both in the Presenter and the data attribute
            hisPresenter.setNanny(_nanny);
            $dropedElement.data('nanny', _nanny);

            //add to our fields
            view.addTopField(hisPresenter);
            _nanny.addChildAfter(0, hisPresenter);
        }
    });

    var _updateSort = function(fieldDefs, start){
        fieldDefs.forEach(function(fieldDef){
            if (fieldDef) { // todo jone só está aqui por causa dos testes
                fieldDef.order = start++;
                if (fieldDef.fields) start = _updateSort(fieldDef.fields, start);
            }
        });

        return start;
    };

    return {

        showFields: function(fieldDefinitions, readOnly){

            //we add a new Presenter for each field definition
            fieldDefinitions.forEach(function(fieldDefinition) {
                var newFieldP = _fieldBuilder.buildFor(_nanny, fieldDefinition, readOnly);

                view.addBottomField(newFieldP);
                _nanny.addChild(newFieldP);
            });


            //we disable things if in read-only mode
            if(readOnly) view.setReadonly();
        },

        showErrors: function(errors){
            _nanny.getChildren().forEach((p) => p.showErrors(errors));
        },

        updateModel: function(definitionM){
            var fieldDefs = _nanny.getChildren().map(function (fieldP) {
                return fieldP.getFieldDef();
            });

            delete definitionM.data.fieldDefinitions;

            if(fieldDefs.length > 0){
                definitionM.data.fieldDefinitions = fieldDefs;

                _updateSort(definitionM.data.fieldDefinitions, 1);
            }

        }
    }

};

export default DefinitionFieldsP;
